import { render, staticRenderFns } from "./CourseTimeRecords.vue?vue&type=template&id=b0d867fe&"
import script from "./CourseTimeRecords.vue?vue&type=script&lang=js&"
export * from "./CourseTimeRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports